export default function LegalPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sotomago.com';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '特定商取引法に基づく表記 - ソトマゴ',
    description: 'ソトマゴの特定商取引法に基づく表記ページです。',
    url: `${siteUrl}/legal`,
    inLanguage: 'ja',
    isPartOf: {
      '@type': 'WebSite',
      name: 'ソトマゴ',
      url: siteUrl
    }
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-brand-dark mb-12 text-center">特定商取引法に基づく表記</h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">事業者名</h2>
              <p className="text-gray-700">ソトマゴ</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">代表者</h2>
              <p className="text-gray-700">山瀬 純</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">所在地</h2>
              <p className="text-gray-700">〒680-0035<br />鳥取県鳥取市新町214</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">電話番号</h2>
              <p className="text-gray-700">
                <a href="tel:+817090045641" className="hover:text-brand-yellow transition-colors duration-300">
                  070-9004-5641
                </a>
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">受付時間</h2>
              <p className="text-gray-700">9:00〜18:00（サービス提供はご予約内容に応じて対応）</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">サービス内容</h2>
              <p className="text-gray-700">
                外出前の準備サポート、送迎サポート、外出先での付き添い、生活サポート、健康運動サポート、家族への報告サポート 等<br />
                <span className="text-sm mt-2 inline-block">※ 福祉タクシー許可・国家資格保有者による専属ヘルパーサービスです。</span>
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">料金</h2>
              <p className="text-gray-700">
                サポート内容に応じて事前にお見積もりいたします。
              </p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">お支払い方法</h2>
              <p className="text-gray-700">現金、銀行振込、クレジットカード、キャッシュレス決済各種、明細書払い</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">サービス提供時期</h2>
              <p className="text-gray-700">ご予約確定後、お客様とご相談の上、日時を決定いたします。</p>
            </div>

            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-xl font-bold text-brand-dark mb-3">キャンセルポリシー</h2>
              <p className="text-gray-700">
                前日18:00までのキャンセルは無料です。<br />
                それ以降のキャンセルについては、予約時間分をご請求させていただきます。<br />
                <span className="text-sm mt-2 inline-block">※急な体調不良等で、開始３時間前までにご連絡いただき日程変更される場合は、キャンセル料は発生いたしません。</span><br />
                <span className="text-sm inline-block">※営業時間外はお電話をお受けいたしかねますので、あらかじめご了承ください。</span>
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-brand-dark mb-3">返品・交換について</h2>
              <p className="text-gray-700">
                役務提供の性質上、返品・交換はお受けできません。<br />
                サービス内容に関するご相談は随時承ります。
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="/#hero"
              className="inline-flex items-center text-brand-dark hover:text-brand-yellow transition-colors duration-300 font-medium cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              トップページに戻る
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
